module.exports = __webpack_public_path__ + "img/cocokind_thumbnail.76c38b90.jpg";